
export enum EModalType {
    CONFIRMATION = 'CONFIRMATION',
    ALERT = 'ALERT'
}